import { Check } from "lucide-react";

/**
 * A per-category goal as a progress bar: label, current/target (0–100 scale), and
 * an "Achieved" marker that fills the bar green. `current` is null with no data.
 */
export function GoalBar({
	label,
	current,
	target,
	achieved,
}: {
	label: string;
	current: number | null;
	target: number;
	achieved: boolean;
}) {
	const pct = current != null ? Math.min(100, Math.round((current / target) * 100)) : 0;
	return (
		<div className="flex flex-col gap-1.5 py-2.5">
			<div className="flex items-center justify-between">
				<span className="flex items-center gap-2 text-sm">
					{label}
					{achieved ? (
						<span className="flex items-center gap-1 text-xs font-medium text-semantic-success">
							<Check className="h-3 w-3" /> Achieved
						</span>
					) : null}
				</span>
				<span className="font-mono text-xs tabular-nums text-ink-subtle">
					{current ?? "—"} / {target}
				</span>
			</div>
			<div className="h-1 w-full overflow-hidden rounded-full bg-surface-3">
				<div
					className={`h-full rounded-full transition-[width] duration-300 ${achieved ? "bg-semantic-success" : "bg-primary"}`}
					style={{ width: `${achieved ? 100 : pct}%` }}
				/>
			</div>
		</div>
	);
}
